import TempSelectionLine from './tempSelectionCellForReports'
export default TempSelectionLine
